import Header from "../components/header";
import HomepageHero from "../components/homepage-hero";
import MediaAndText from "../components/media-and-text";
import TestEnvironment from "../components/test-environment";
import PricingHolder from "../components/pricing-holder";

function HomePage(){
    const navigateToLoginPage = () => {
        window.location.href = '/signup';
    }

    return <>
    <Header CTA='Sign up' functionForButton={navigateToLoginPage}></Header>
    <HomepageHero></HomepageHero>
    <TestEnvironment />    
    <PricingHolder />  
    </>
}
    
export default HomePage;